import _ from 'lodash';

type TFunction = (key: string) => string;

/**
 * Allowlist for promotion codes: ASCII letters, digits, underscore and hyphen, 1-64 characters.
 *
 * DUPLICATED BY NECESSITY. The canonical definition lives in the lgs-web repo at
 * `libs/utils/promotionCode.ts` (exported as `@tv2-lgs/lib-utils/promotionCode`), where
 * the storefront rejects codes that fall outside this allowlist. The two repos cannot
 * share code, so this copy must be kept in sync with lgs-web — change one, change both.
 *
 * Without this check a code containing e.g. a space or a slash is accepted here but
 * silently dropped by checkout, and the campaign renders at full price with no visible cause.
 */
export const PROMOTION_CODE_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

class ValidationUtils {
    static validateDiscountDuration(discountDuration: string|number, t: TFunction) {
      const discountDurationValue = _.toNumber(discountDuration);
      if(discountDurationValue && discountDurationValue !== 0 && discountDurationValue % 30 === 0)
        return true;

      return t('promotion.promotionDiscountDurationInvalid');
    };

    static isValidPromotionCode(promotionCode: string) {
      return typeof promotionCode === 'string' && PROMOTION_CODE_PATTERN.test(promotionCode);
    };
}

export default ValidationUtils;